import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";


export const loadRequestIndentNumber = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.REQUEST_INDENT_GET_CODE, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}
export const loadRequestIndentlist = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.REQUEST_INDENT_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const RequestIndentCRUD = async (api, payload) => {
    try {       
        return await callApi(api, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error processing request indent:", error);
        throw error;  // Ensure the error is properly propagated
    }
};

export const loadRequestIndentNumberlist = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.LIST_OUT_REQUEST_NO_BY_DEPARTMENT_ID, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

